import { SvgIcon, SvgIconProps } from '@mui/material';

const AnalyticsFilled = ({ fill, fillOpacity, sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      data-testid="AnalyticsFilledIcon"
      sx={{
        fill: fill,
        fillOpacity: fillOpacity ?? 1,
        ...sx
      }}
    >
      <path d="M2 3C2 2.44772 2.44772 2 3 2C3.55228 2 4 2.44772 4 3V15H6.51855L10.2188 10.375L10.2852 10.2998C10.6319 9.94505 11.1946 9.89652 11.5996 10.2002L14.5449 12.4092L17.1787 5.6377L17.2266 5.53418C17.35 5.29983 17.5622 5.12241 17.8184 5.04395C18.1111 4.95432 18.429 5.00349 18.6807 5.17773L21.5693 7.17773C21.8391 7.36452 22 7.67188 22 8V21C22 21.5523 21.5523 22 21 22H3C2.44772 22 2 21.5523 2 21V3Z" />
    </SvgIcon>
  );
};

export default AnalyticsFilled;
